import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { Button, Divider, Grid } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import OneTimeLoginLink from "../../components/OneTimeLoginLink";
import { useConfig } from "../auth";
import ProviderList from "../socialaccount/ProviderList";


export interface AlternateSignInOptionsProps {
  /** Link to email + password sign-in page */
  emailPasswordHref?: string;
  emailPasswordLabel?: string;
  /** Link to SMS sign-in/up */
  smsHref?: string;
  smsLabel?: string;
  showMagicLink?: boolean;
  magicLinkEmail?: string;
  magicLinkDefaultOpen?: boolean;
  onNavigateAway?: () => void;
  smsDataAttr?: string;
  emailPasswordDataAttr?: string;
}

const AlternateSignInOptions: React.FC<AlternateSignInOptionsProps> = ({
  emailPasswordHref,
  emailPasswordLabel = "Sign in with Email and Password",
  smsHref,
  smsLabel = "Sign in with SMS",
  showMagicLink = false,
  magicLinkEmail = "",
  magicLinkDefaultOpen = false,
  onNavigateAway,
  smsDataAttr = "alternate-signin_sms",
  emailPasswordDataAttr = "alternate-signin_email-password",
}) => {
  const config = useConfig();
  const hasProviders =
    (config.data.socialaccount?.providers?.length ?? 0) > 0;
  const hasAlternateMethods =
    hasProviders || Boolean(emailPasswordHref) || Boolean(smsHref) || showMagicLink;

  if (!hasAlternateMethods) {
    return null;
  }

  return (
    <>
      <Divider sx={{ width: "100%", backgroundColor: "primary.dark", my: 2 }} />

      {hasProviders && (
        <Grid item style={{ marginTop: 50 }}>
          <ProviderList callbackURL="/account/provider/callback" />
        </Grid>
      )}

      {emailPasswordHref && (
        <Button
          component={Link}
          sx={{ mt: 2 }}
          to={emailPasswordHref}
          variant="contained"
          color="secondary"
          fullWidth
          startIcon={<EmailIcon />}
          onClick={() => onNavigateAway?.()}
          data-attr={emailPasswordDataAttr}
        >
          {emailPasswordLabel}
        </Button>
      )}

      {showMagicLink && (
        <Grid item sx={{ mt: 2, width: "100%" }}>
          <OneTimeLoginLink
            email={magicLinkEmail}
            defaultOpen={magicLinkDefaultOpen}
            layout="modal"
            fullWidth
            variant="contained"
            color="secondary"
            dataAttr="alternate-signin_magic-link"
          />
        </Grid>
      )}

      {smsHref && (
        <Button
          component={Link}
          sx={{ mt: 2 }}
          to={smsHref}
          variant="contained"
          color="secondary"
          fullWidth
          startIcon={<PhoneIcon />}
          onClick={() => onNavigateAway?.()}
          data-attr={smsDataAttr}
        >
          {smsLabel}
        </Button>
      )}
    </>
  );
};

export default AlternateSignInOptions;
